import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";
import {
    FIN_TRANS_ACTIVE_QUARTERS,
    FIN_TRANS_CURRENT_QUARTER,
    FIN_TRANS_PAYMENTS_EXPORT,
    FIN_TRANS_PAYMENTS_SEARCHABLE,
    FIN_TRANS_REPORTABLE_SCHOOL_YEARS,
    FIN_TRANS_SEARCH_LOG_CREATE
} from "../const/FinTransConst";

/**
 * Data Access for the Financial Transparency API
 * @name FinTransDao
 * @param {*} props
 */
const FinTransDao = (props) => {
    const { action, data, params, schoolYearKey, token } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        }
    };
    switch (action) {
        case "ftCurrentQuarterRead":
            options.method = "GET";
            options.url = FIN_TRANS_CURRENT_QUARTER;
            break;
        case "ftActiveQuartersRead":
            options.method = "GET";
            options.url = `${FIN_TRANS_ACTIVE_QUARTERS}/${schoolYearKey}/index.json`;
            break;
        case "ftPaymentsExport":
            options.headers.Accept = "application/csv";
            options.method = "GET";
            if (params) {
                options.params = params;
            }
            options.responseType = "arraybuffer";
            options.url = FIN_TRANS_PAYMENTS_EXPORT;
            break;
        case "ftReportableSchoolYearsRead":
            options.method = "GET";
            options.url = FIN_TRANS_REPORTABLE_SCHOOL_YEARS;
            break;
        case "ftPaymentsSearchableRead":
            options.method = "GET";
            if (params) {
                options.params = params;
            }
            options.url = FIN_TRANS_PAYMENTS_SEARCHABLE;
            break;
        case "ftSearchLogCreate":
            options.data = data;
            options.method = "POST";
            options.url = FIN_TRANS_SEARCH_LOG_CREATE;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

FinTransDao.propTypes = {
    action: PropTypes.string.isRequired,
    data: PropTypes.oneOfType([PropTypes.object]),
    params: PropTypes.oneOfType([PropTypes.object]),
    schoolYearKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    token: PropTypes.string.isRequired
};

FinTransDao.defaultProps = {
    data: null,
    params: null,
    schoolYearKey: null
};

export default FinTransDao;
